module.exports = __webpack_public_path__ + "img/Caret.b1497f91.svg";